module.exports = __webpack_public_path__ + "fonts/answer-received-gray.svg";